import { registerSW } from 'virtual:pwa-register'

/**
 * Registers the service worker. With `registerType: 'autoUpdate'` a new SW
 * activates automatically; we reload once it takes control to pick up the
 * latest assets.
 */
export function setupPWA() {
  const enableDevPwa =
    import.meta.env.VITE_PWA_DEV === '1' ||
    import.meta.env.VITE_PWA_DEV === 'true'

  if (import.meta.env.DEV && !enableDevPwa) return

  registerSW({
    immediate: true,
    onRegisteredSW(swUrl, registration) {
      if (import.meta.env.DEV) {
        console.info('[PWA] Service worker registrado', {
          swUrl,
          scope: registration?.scope,
          active: Boolean(registration?.active),
        })
      }

      // Check for updates periodically while the app stays open.
      if (registration) {
        setInterval(
          () => {
            void registration.update()
          },
          60 * 60 * 1000
        )
      }
    },
    onRegisterError(error) {
      console.error('[PWA] Falha ao registrar service worker', error)
    },
  })
}
